<script>
  import { onDestroy } from 'svelte';
  import { activeLowerThird } from '../store.js';

  export let popup = null; // { type, title, subtitle, badge, color, durationMs }
  export let mode = 'overlay'; // overlay | stacked (camera safe-zone) | inline

  let visible = false;
  let timer = null;

  $: if (popup && popup.title) {
    visible = true;
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      visible = false;
      // Also clear the store. Leaving the old payload in place meant an
      // identical popup later produced no reactive change, so it silently
      // never appeared again.
      activeLowerThird.set(null);
    }, popup.durationMs || 4500);
  }

  onDestroy(() => {
    if (timer) clearTimeout(timer);
  });
</script>

{#if visible && popup}
  <div class="lower-third-banner {mode}" style="border-left: 4px solid {popup.color || '#ef4444'};">
    <div class="banner-badge" style="background: {popup.color || '#ef4444'};">
      {popup.badge}
    </div>
    <div class="banner-content">
      <div class="b-title">{popup.title}</div>
      <div class="b-subtitle">{popup.subtitle}</div>
    </div>
  </div>
{/if}

<style>
  .lower-third-banner {
    display: flex;
    align-items: center;
    gap: 12px;
    background: rgba(7, 12, 24, 0.94);
    backdrop-filter: blur(16px);
    -webkit-backdrop-filter: blur(16px);
    border: 1px solid rgba(239, 68, 68, 0.25);
    border-radius: 10px;
    padding: 8px 14px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.6), 0 0 15px rgba(220, 38, 38, 0.2);
  }

  .lower-third-banner.overlay {
    position: absolute;
    bottom: 58px; /* Positioned cleanly above commentary ticker & bottom controls */
    left: 16px;
    z-index: 25;
    animation: slideInLeft 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards;
    max-width: calc(100vw - 32px);
  }

  .lower-third-banner.inline {
    margin: 0;
    animation: fadeInDown 0.3s ease-out forwards;
    width: 100%;
    min-height: 100%;
  }

  .lower-third-banner.stacked {
    position: relative;
    width: min(520px, 100%);
    max-width: 100%;
    animation: slideInLeft 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards;
  }

  @keyframes slideInLeft {
    0% {
      transform: translateX(-100%) scale(0.9);
      opacity: 0;
    }
    100% {
      transform: translateX(0) scale(1);
      opacity: 1;
    }
  }

  @keyframes fadeInDown {
    0% {
      transform: translateY(-10px);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }

  .banner-badge {
    font-size: 10px;
    font-weight: 900;
    color: #070c18;
    padding: 4px 8px;
    border-radius: 6px;
    letter-spacing: 0.5px;
    white-space: nowrap;
    text-transform: uppercase;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
  }

  .banner-content {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
  }

  .b-title {
    font-weight: 900;
    font-size: 13px;
    color: #ffffff;
    letter-spacing: 0.5px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .b-subtitle {
    font-size: 11px;
    color: #cbd5e1;
    font-weight: 700;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>
